module.exports = __webpack_public_path__ + "img/主页5.5e52e339.jpg";